import type { LinkedTargetState } from '../api/types'

type Listener = (state: LinkedTargetState) => void

class TextAnalyticsBus {
	private readonly listeners = new Map<number, Set<Listener>>()

	publish(state: LinkedTargetState): void {
		this.listeners.get(state.blockId)?.forEach((fn) => fn(state))
	}

	subscribe(blockId: number, listener: Listener): () => void {
		let set = this.listeners.get(blockId)
		if (set === undefined) {
			set = new Set()
			this.listeners.set(blockId, set)
		}
		set.add(listener)
		return () => {
			this.listeners.get(blockId)?.delete(listener)
		}
	}
}

export const textAnalyticsBus = new TextAnalyticsBus()
